<template>
  <div>
    <h3 class="text-xl mb-6">General Information</h3>
    <div class="w-full flex flex-wrap">
      <div class="w-full md:w-1/2 pr-3">
        <div class="flex-grow mr-1 mb-6">
          <label for="first_name" class="block text-xs mb-2">First Name<span class="text-propqual-orange">*</span></label>
          <input type="text" id="first_name" v-model="order.first_name" class="input w-full bg-white text-grey-darkest" tabindex="1">
          <small class="block text-propqual-orange text-medium mt-2" v-if="errorBag.get('first_name')" v-text="errorBag.get('first_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="company_name" class="block text-xs mb-2">Company Name / Estate Agency Brand<span class="text-propqual-orange">*</span></label>
          <input type="text" id="company_name" v-model="order.company_name" class="input w-full bg-white text-grey-darkest" tabindex="3">
          <small class="block text-propqual-orange text-medium mt-2" v-if="errorBag.get('company_name')" v-text="errorBag.get('company_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="email_address" class="block text-xs mb-2">Email Address<span class="text-propqual-orange">*</span></label>
          <input type="text" id="email_address" v-model="order.email" class="input w-full bg-white text-grey-darkest" tabindex="5">
          <small class="block text-propqual-orange text-medium mt-2" v-if="errorBag.get('email')" v-text="errorBag.get('email')"></small>
        </div>
      </div>
      <div class="w-full md:w-1/2 pl-3">
        <div class="flex-grow mr-1 mb-6">
          <label for="last_name" class="block text-xs mb-2">Last Name<span class="text-propqual-orange">*</span></label>
          <input type="text" id="last_name" v-model="order.last_name" class="input w-full bg-white text-grey-darkest" tabindex="2">
          <small class="block text-propqual-orange text-medium mt-2" v-if="errorBag.get('last_name')" v-text="errorBag.get('last_name')"></small>
        </div>
        <div class="flex-grow mr-1 mb-6">
          <label for="job_title" class="block text-xs mb-2">Job Title<span class="text-propqual-orange">*</span></label>
          <input type="text" id="job_title" v-model="order.job_title" class="input w-full bg-white text-grey-darkest" tabindex="4">
          <small class="block text-propqual-orange text-medium mt-2" v-if="errorBag.get('job_title')" v-text="errorBag.get('job_title')"></small>
        </div>
      </div>
    </div>
    <div class="w-full mb-8">
      <h4 class="block text-sm font-bold mb-4">Which Course would you like to enroll on?</h4>
      <div v-for="(item, i) in courses" :key="i" class="w-full block mb-4">
        <div class="inline-block pr-2"><input type="radio" :id="'course-' + item.id" class="align-middle cursor-pointer" v-model="order.course_id" :value="item.id" /></div>
        <label :for="'course-' + item.id" class="text-sm align-middle pb-4 cursor-pointer">{{ item.name }}</label>
      </div>
      <div class="w-full block mb-4">
        <div class="inline-block pr-2"><input type="radio" id="course-0" class="align-middle cursor-pointer" v-model="order.course_id" value="" /></div>
        <label for="course-0" class="text-sm align-middle pb-4 cursor-pointer">Neither, I'm enrolling others onto a course</label>
      </div>
      <small class="block text-propqual-orange text-medium mt-2" v-if="errorBag.get('course_id')" v-text="errorBag.get('course_id')"></small>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['courses', 'order', 'errorBag']
}
</script>
